module.exports = __webpack_public_path__ + "img/bgBox_sp.9835a5d0.jpg";